<div class="container-dynamic__without-actions-no-scroll">
  <sabis-grid2 [scColumns]="columns"
               class="full-height-grid"
               [scDataLoader]="dataLoader"
               [title]="title">
              </sabis-grid2>
</div>
